var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1770362596649,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 3137,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M735.138909 651.636364l48.733091-70.144c9.169455-13.218909 9.914182-35.234909 1.582545-49.058909L605.090909 232.727273 735.138909 651.636364z",
    "p-id": 3138,
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M488.727273 1024c27.182545 0 256-128.605091 256-158.859636 0-30.254545-178.082909-643.304727-178.082909-643.304727l137.914182-181.527273c0 0 32.162909-40.308364-32.162909-40.308364L307.805091 0C243.432727 0 264.890182 40.308364 264.890182 40.308364l145.92 181.527273C410.810182 221.835636 232.727273 831.301818 232.727273 865.140364 232.727273 898.978909 461.544727 1024 488.727273 1024zM468.619636 209.175273 339.176727 46.545455l295.098182 0L508.834909 209.175273c0 0 166.074182 628.456727 166.074182 638.603636 0 10.146909-186.181818 107.008-186.181818 107.008s-186.181818-93.230545-186.181818-107.008C302.545455 834.048 468.619636 209.175273 468.619636 209.175273z",
    "p-id": 3139,
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTie);
export default __webpack_public_path__ + "static/media/tie.64322b45.svg";
export { ForwardRef as ReactComponent };